import { ChevronUp, ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";

// Shared mobile pull-up tray (portrait) / left slide-in drawer (landscape).
// Sizing is controlled by a `sheet` object from useSheetSize(): drag the grab handle
// to any height, or tap it to toggle collapsed. Height is remembered per device.
export function MobileTray({ sheet, title, count, children, testid = "m-tray" }) {
  const { height, collapsed, setCollapsed, grabberProps } = sheet;
  return (
    <>
      <div
        style={{ height }}
        className={`absolute z-[1100] bg-[#0C1017] ${collapsed ? "overflow-hidden" : "overflow-y-auto"} transition-transform duration-300 left-0 right-0 bottom-0 rounded-t-2xl border-t border-white/10 shadow-[0_-8px_30px_rgba(0,0,0,0.55)] landscape:!h-full landscape:top-0 landscape:bottom-0 landscape:right-auto landscape:w-[340px] landscape:rounded-none landscape:rounded-r-2xl landscape:border-t-0 landscape:border-r landscape:border-white/10 landscape:shadow-[8px_0_30px_rgba(0,0,0,0.6)] ${collapsed ? "landscape:-translate-x-full" : "landscape:translate-x-0"}`}
        data-testid={testid}>
        <div {...grabberProps} data-testid={`${testid}-grabber`}
          className="landscape:hidden sticky top-0 z-10 w-full bg-[#0C1017]/95 backdrop-blur pt-2 pb-2 border-b border-white/10 flex flex-col items-center select-none">
          <span className="w-10 h-1.5 rounded-full bg-white/25 mb-1.5" />
          <span className="flex items-center gap-2 text-[13px] font-bold text-slate-200">
            {collapsed ? <>Drag up or tap to show list <ChevronUp className="w-4 h-4" /></> : <>{count} {title} <ChevronDown className="w-4 h-4" /></>}
          </span>
        </div>
        <div className="hidden landscape:flex items-center gap-2 px-4 py-2.5 text-sm font-bold text-slate-300 border-b border-white/10">{count} {title}</div>
        {!collapsed && children}
      </div>
      <button onClick={() => setCollapsed(!collapsed)} data-testid={`${testid}-ls-toggle`}
        title={collapsed ? "Show list" : "Hide list"}
        className={`hidden landscape:flex absolute z-[1101] top-1/2 -translate-y-1/2 items-center justify-center w-6 h-14 rounded-r-lg bg-[#C8000F] text-white shadow-lg transition-all duration-300 ${collapsed ? "left-0" : "left-[340px]"}`}>
        {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
      </button>
    </>
  );
}
